module.exports = "\r\n\r\n\r\n<img src=\"{{ imgUrl }}\" />\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/imageprocess/imageprocess.component.html
// module id = ../../../../../src/app/_components/imageprocess/imageprocess.component.html
// module chunks = 1